export const throttled = (fn, delay = 1000) => {
  let lastCall = 0;
  return (...rest) => {
    const now = Date.now();

    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...rest);
  };
};

export const debounced = (fn, delay = 1000) => {
  let timerId;
  return (...args) => {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      fn(...args);
      timerId = null;
    }, delay);
  };
};

export const getFileSize = item => {
  if (item.size < 1024) {
    return `${item.size} B`;
  }
  if (item.size < Math.pow(1024, 2)) {
    return `${(item.size / 1024).toFixed(2)} KB`;
  }
  if (item.size < Math.pow(1024, 3)) {
    return `${(item.size / Math.pow(1024, 2)).toFixed(2)} MB`;
  }
  return `${(item.size / Math.pow(1024, 3)).toFixed(2)} GB`;
};

export const getSmallFileUrl = (url, size = 40) => {
  const [begin, end] = url.split('/upload');
  return `${begin}/upload/w_${size}${end}`;
};

export const getColumnsWidth = () => {
  const columnsWidth = JSON.parse(localStorage.getItem('columnsWidth')) || {};
  return columnsWidth[window.location.pathname] || {};
};

export const setColumnsWidth = ({ actualWidth, colId }) => {
  const columnsWidth = JSON.parse(localStorage.getItem('columnsWidth')) || {};
  columnsWidth[window.location.pathname] =
    columnsWidth[window.location.pathname] || {};
  columnsWidth[window.location.pathname][colId] = actualWidth;
  localStorage.setItem('columnsWidth', JSON.stringify(columnsWidth));
};
